import React from "react"
import { graphql, Link } from "gatsby"

import Bio from "../components/bio"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { GatsbyImage } from "gatsby-plugin-image"
import tw, { styled } from "twin.macro"
import { MDXRenderer } from "gatsby-plugin-mdx"

const Article = styled.article(() => [
  `.article-image, .gatsby-resp-image-wrapper {
    border: 1rem solid white; box-shadow: 0 2px 70px rgba(68,68,68,.18); border-radius: .25rem;
  }
  .gatsby-resp-image-image {
    border-radius: .25rem
  }
  .gatsby-resp-image-figcaption {
    text-align:center
  }`,
  tw`prose lg:prose-xl`,
])

const Wrapper = tw.div`p-5 py-2 lg:p-0 lg:py-10 flex flex-col items-center max-w-screen-xl m-auto`

const StyledLink = styled(Link)([
  tw`fixed hidden z-10 lg:block lg:pl-5 md:pl-0 lg:w-auto  self-start lg:px-10 xl:px-8 font-condensed uppercase hover:font-bold transition duration-300 ease`,
])

const BlogPostTemplate = ({ data, location }) => {
  const post = data.mdx
  const siteTitle = data.site.siteMetadata?.title || `Title`
  const featuredImgFluid =
    post.frontmatter?.featuredImage?.childImageSharp?.gatsbyImageData || null
  const showFeaturedImageOnTop = post.frontmatter?.featureOnTop || false
  
  const publish_date = post.frontmatter?.lastUpdated != null ? 
    "Last updated on " + post.frontmatter?.lastUpdated : post.frontmatter?.date

  return (
    <Layout location={location} title={siteTitle}>
      <SEO
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
        image={data.site.siteMetadata?.siteHost + post.frontmatter?.featuredImage?.childImageSharp?.gatsbyImageData?.images?.fallback?.src}
      />
      <Wrapper>
        <StyledLink to="/">
          <span>&#8592;&nbsp;All posts</span>
        </StyledLink>
        <Article itemScope itemType="http://schema.org/Article">
          <header>
            {featuredImgFluid && showFeaturedImageOnTop && (
              <div>
                <GatsbyImage
                  alt={post.frontmatter?.featuredImageAlt}
                  className="article-image"
                  image={featuredImgFluid}
                  imgStyle={{
                    margin: 0,
                  }}
                />
              </div>
            )}
            <h1 tw="first:pt-0 pt-10" itemProp="headline">
              {post.frontmatter.title}
            </h1>
            <p>{publish_date}</p>
          </header>
          <MDXRenderer itemProp="articleBody">{post.body}</MDXRenderer>
          <hr />
          <footer>
            <Bio />
          </footer>
        </Article>
      </Wrapper>
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($id: String!) {
    site {
      siteMetadata {
        title
        siteHost
      }
    }
    mdx(id: { eq: $id }) {
      id
      excerpt(pruneLength: 160)
      body
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        lastUpdated(formatString: "MMMM DD, YYYY")
        description
        featureOnTop
        featuredImageAlt
        featuredImage {
          childImageSharp {
            gatsbyImageData(width: 800, layout: CONSTRAINED)
          }
        }
      }
    }
  }
`
